export default "__VITE_ASSET__BLilj_tz__"